// extracted by mini-css-extract-plugin
export default {"aypaModal":"modal_aypaModal__pnEjs"};